import { useId, useState } from "react";
import { glossar } from "../lib/glossar";

/**
 * Erklaer-Icon für einen Fachbegriff. Nutzt das zentrale Glossar.
 * <Hint term="trust_gate" />  oder  <Hint term="kpi">Kennzahl</Hint>
 */
export function Hint({ term, children }: { term: string; children?: React.ReactNode }) {
  const entry = glossar(term);
  const [open, setOpen] = useState(false);
  const id = useId();
  if (!entry) return <>{children}</>;
  return (
    <span className="hint-wrap">
      {children}
      <button
        type="button"
        className={`hint-btn ${open ? "open" : ""}`}
        aria-label={`Was bedeutet ${entry.titel}?`}
        aria-expanded={open}
        aria-describedby={id}
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen((v) => !v); }}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
      >
        i
      </button>
      {open && (
        <span className="hint-pop" role="tooltip" id={id}>
          <strong>{entry.titel}</strong>
          <span>{entry.kurz}</span>
          {entry.lang && <em>{entry.lang}</em>}
        </span>
      )}
    </span>
  );
}

export default Hint;
